






























































































import { Vue, Component } from "vue-property-decorator";
import { auth, VipCertificateStatus, VipCapabilityStatus, VIPCertificate, VipProjectStatus } from "@/loader";
import CapabilitiesWidget from "../component/capability/CapabilitiesWidget.vue";
import CapabilitiesTreeWidget from "../component/capability/CapabilitiesTreeWidget.vue";
import CertificatesWidget from "../component/certificate/CertificatesWidget.vue";
import ProjectsWidget from "../component/project/ProjectsWidget.vue";
import CertificatePdfModal from "../component/certificate/CertificatePdfModal.vue";

@Component({
	components: {
		CapabilitiesWidget,
		CapabilitiesTreeWidget,
		CertificatesWidget,
		CertificatePdfModal,
		ProjectsWidget,
	}
})
export default class Home extends Vue {
	public certificate: VIPCertificate | null = null;
	public certificateStatus = VipCertificateStatus;
	public projectStatus = VipProjectStatus;
	public capabilityStatus = VipCapabilityStatus;

	public get isAdmin(): boolean {
		return auth.user?.isAdmin || false;
	}

	public get isAdministrative(): boolean {
		return auth.user?.isAdministrative || false;
	}

	public get isManager(): boolean {
		return auth.user?.isManager || false;
	}

	public get isSupervisor(): boolean {
		return auth.user?.isSupervisor || false;
	}

	public get isSupervisorOrAbove(): boolean {
		return auth.user?.isSupervisorOrAbove || false;
	}

	public selectCertificate(value: VIPCertificate | null) {
		this.certificate = value;
		if (value) {
			this.$nextTick(() => this.$bvModal.show("pdf_modal"));
		}
	}
}
